"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var teams_theme_context_1 = require("./teams-theme-context");

function connectTeamsComponent(Component) {
  return function (props) {
    return React.createElement(teams_theme_context_1.TeamsThemeContext.Consumer, null, function (context) {
      return React.createElement(Component, Object.assign({}, props, {
        context: context
      }));
    });
  };
}

exports.connectTeamsComponent = connectTeamsComponent;